import {percent} from '@packages/systems/core/utils/WebflowCssSubset';
import View from '../View';
import {SHARED_FORM_WRAPPER_CONSTRAINTS_DESCENDANTS} from '@packages/systems/core/constants/SharedConstraintRules';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';

const config = createIntegratedAtom({
  displayName: 'Cart Form Wrapper',
  showEmpty: true,
  constraints: {
    ancestors: [{is: 'CommerceCartContainer', rule: 'ExactlyOne'}],
    descendants: SHARED_FORM_WRAPPER_CONSTRAINTS_DESCENDANTS,
    wraps: [
      'CommerceCartForm',
      'CommerceCartEmptyState',
      'CommerceCartErrorState',
    ],
  },
  style: {
    base: {
      main: {
        noPseudo: {
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          flexShrink: 1,
          flexBasis: percent(0),
        },
      },
    },
  },
  render: View,
  fields: {children: TListOfElement},
});

export default config;
